import * as React from 'react';

interface IListHeaderButtonProps {
  text: string;
  onClick: () => void;
}

const ListHeaderButton: React.FunctionComponent<IListHeaderButtonProps> = (
  props
) => {
  return (
    <div className="dropdown dropdown-action">
      <button
        className="btn btn-primary font-normal font-weight-bold px-3"
        type="button"
        id="dropdownMenuButton"
        onClick={() => {
          props.onClick();
        }}
      >
        <i className="icon-plus mr-2"></i>
        <span className="p-2 action-border">
          <span className="pl-1 pr-3">{props.text}</span>
        </span>
      </button>
    </div>
  );
};

export default ListHeaderButton;
